module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"On-hold Tournament","description":"Paused tournament as more participants join"},"es":{"title":"Torneo En Espera","description":"Torneo pausado mientras más participantes se unen"}}')
  delete Component.options._Ctor
}
